import React from 'react';
import styles from './contact-form.module.css';

const SUCCESS_MESSAGE = 'Thanks, we\'ll be in touch shortly!';
const ERROR_MESSAGE = 'Something went wrong! Please email us directly at hello@artiseq.com';

const INITAL_FORM_STATE = {
    name: '',
    email: '',
    phone: '',
    message: ''
}

const INITIAL_FORM_ERRORS = {
    name: false,
    email: false,
    phone: false,
    message: false
}

class ContactForm extends React.Component {

    state = {
        submitting: false,
        submitted: false,
        error: false,
        message: '',
        data: { ...INITAL_FORM_STATE },
        fieldErrors: { ...INITIAL_FORM_ERRORS }
    }

    constructor(props) {
        super(props)
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({
            ...this.state,
            submitting: true,
            submitted: true
        });

        if (!this.isFormValid()) {
            this.stopSubmitting();
            return;
        }

        fetch('/', {
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: this.encode({ 'form-name': 'contact', ...this.state.data })
        })
        .then(this.handleSuccess.bind(this))
        .catch(this.handleError.bind(this));
    }

    stopSubmitting() {
        this.setState({
            ...this.state,
            submitting: false
        });
    }

    isFormValid() {
        const keys = Object.keys(this.state.fieldErrors);

        keys.map(k => {
            this.state.fieldErrors[k] = this.state.data[k] === ''
        });

        return keys.some(k => !this.state.fieldErrors[k]);
    }

    encode(data) {
        return Object.keys(data)
            .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join("&");
    }

    handleSuccess() {
        this.setState({
            ...this.state,
            message: SUCCESS_MESSAGE
        });
        this.resetForm();
    }

    handleError() {
        this.setState({
            ...this.state,
            error: ERROR_MESSAGE
        });
        this.resetForm();
    }

    resetForm() {
        this.setState({
            ...this.state,
            submitting: false,
            submitted: false,
            data: { ...INITAL_FORM_STATE }
        });
    }

    handleChange(field, data) {
        this.setState({
            ...this.state,
            data: {
                ...this.state.data,
                [field]: data
            }
        });

        this.isFormValid();
    }

    render() {
        return (
            <div className={styles.contactForm}>
                {this.state.message && <div className={styles.message}>
                    {this.state.message}
                </div>}
                {this.state.error && <div className={styles.errorMessage}>
                    {this.state.error}
                </div>}
                <form onSubmit={this.handleSubmit.bind(this)} data-netlify="true" name="contact" method="POST" action="/thanks/" data-netlify-honeypot="bot-field" ref={(elem) => this.form = elem}>
                    <input type="hidden" name="form-name" value="contact" />
                    <input name="bot-field" onChange={this.handleChange} hidden />
                    <input type='text' name="name" className={[styles.input, this.state.submitted && this.state.fieldErrors.name ? styles.error : ''].join(' ')} value={this.state.data.name} onChange={(e) => this.handleChange('name', e.target.value)} placeholder='Your name' />
                    <input type='email'name="email" className={[styles.input, this.state.submitted && this.state.fieldErrors.email ? styles.error : ''].join(' ')} value={this.state.data.email} onChange={(e) => this.handleChange('email', e.target.value)} placeholder='Your email' />
                    <input type='tel' name="phone" className={[styles.input, this.state.submitted && this.state.fieldErrors.phone ? styles.error : ''].join(' ')} value={this.state.data.phone} onChange={(e) => this.handleChange('phone', e.target.value)} placeholder='Your phone' />
                    <textarea name="message" className={[styles.textarea, this.state.submitted && this.state.fieldErrors.message ? styles.error : ''].join(' ')} value={this.state.data.message} onChange={(e) => this.handleChange('message', e.target.value)} placeholder='Your message' rows='5'></textarea>
                    <button type='submit' disabled={this.state.submitting === true} className={styles.button}>Send</button>
                </form>
            </div>
        );
    }

}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js